module.exports = __webpack_public_path__ + "media/images/icons/twotone/flag-7c5a22893b82894498712b31249cb366.svg";